import { CanMatchFn } from '@angular/router';

import { environment } from '@finverity/platform-app/env/environment';

/**
 * Blocks direct URL access to the Notification Templates routes on deployments
 * that hide the feature (e.g. QNB and air-gap). When it denies the match, the
 * router falls through to the wildcard route which redirects to the dashboard.
 */
export const CanMatchNotificationTemplatesRoute: CanMatchFn = () => !environment.platform.hideNotificationTemplates;
